




































import { Component } from 'vue-property-decorator';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import GeneralLedgerAccountDetails from '@/components/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountDetails.vue';
import GeneralLedgerAccountJournalEntries from '@/components/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountJournalEntries.vue';

@Component({ name: 'GeneralLedgerAccount', components: { Alert, GeneralLedgerAccountDetails, GeneralLedgerAccountJournalEntries }, metaInfo: { title: 'General Ledger Accounts' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await GeneralLedgerAccountsModule.getGeneralLedgerAccount(this.$route.params.id);
    }

    get generalLedgerAccount() {
        return GeneralLedgerAccountsModule.generalLedgerAccount;
    }

    get loading() {
        return GeneralLedgerAccountsModule.loadingGeneralLedgerAccount;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
